import React from 'react';
import Banner from './Banner';
import Latest from './Latest';
import You from './You';

const Youtube = ({coach, latestNews}) => {
    
    return (
        <div className='grid md:grid-cols-[20%_minmax(60%,_1fr)_20%] sm:grid-cols-[30%_minmax(70%,_1fr)]'>
            <You coach={coach}/>
            <div className=''>
                <Banner coach={coach}></Banner>
            </div>
            <Latest btn='More' latestNews={latestNews}></Latest>
            
        </div>
    );
};

export default Youtube;